import React from "react";
import Modal from "../app2components/base/Modal/Modal";
import HelpConstants from "../constants/HelpConstants";
import styles from "./TutorialVideoModal.module.css";

/**
 * Modal that plays the intro tutorial video in a 16:9 embed.
 *
 * @component
 * @param {Object} props - The component props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {Function} props.onHide - Callback invoked when the modal is dismissed
 * @returns {React.ReactElement} The tutorial video modal
 */
const TutorialVideoModal = ({ show, onHide }) => (
  <Modal
    isOpen={show}
    onClose={onHide}
    title="Intro to Showit"
    size={null} // opt out of preset widths; sized via styles.modal below
    className={styles.modal}
  >
    <div className={styles.videoWrapper}>
      <iframe
        src={HelpConstants.TUTORIAL_VIDEO_URL}
        className={styles.iframe}
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
        title="Intro to Showit"
      />
    </div>
  </Modal>
);

export default TutorialVideoModal;
